import React, { useState, useEffect } from 'react';
import { Button, Table, Form, ButtonGroup, Dropdown, Pagination } from 'react-bootstrap';
import { CashStack, PencilFill, EyeFill, XCircleFill, ThreeDotsVertical, Filter, ArrowClockwise } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import FiltroFacturas from './filtrosFacturas';
import CustomToggle from '../../styles/customToggle';
import CrearPagoResModal from '../../PagosResibidos/componentes/crearPagoResModal';
import Swal from 'sweetalert2';
import APIserver from '../../../../api/axiosConfig';
import CrearModalDev from '../../devoluciones/componentes/crearModalDev';

function TablaFacturas() {
    const [facturas, setFacturas] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [filters, setFilters] = useState({});
    const [showFilters, setShowFilters] = useState(true);
    const [selectedFactura, setSelectedFactura] = useState(null);
    const [showPagoModal, setShowPagoModal] = useState(false); // Estado para el modal de pago
    const [showDevModal, setShowDevModal] = useState(false);   // Estado para el modal de devolución

    useEffect(() => {
        const fetchFacturas = async () => {
            try {
                const response = await APIserver.get(`/api/Mostrar/facturas`, {
                    params: {
                        page: currentPage,
                        rowsPerPage,
                        ...filters
                    }
                });

                setFacturas(response.data.facturas);
                //console.log(response.data.facturas);

                if (Object.keys(filters).length === 0) {
                    setTotalPages(response.data.totalPages);
                } else {
                    setTotalPages(response.data.totalPages);
                }

            } catch (error) {
                console.error('Error al obtener facturas:', error);
            }
        };

        fetchFacturas();
    }, [currentPage, rowsPerPage, filters]);

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value));
        setCurrentPage(1); // Resetear a la primera página
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1); // Resetear a la primera página cuando cambian los filtros
    };


    // Función para anular factura
    const anularFactura = async (factura) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: `Estás a punto de anular la factura ${factura.numeroFactura}. Esta acción no se puede deshacer.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, anular',
            cancelButtonText: 'Cancelar',
            iconColor: '#f4bd61',
            confirmButtonColor: '#2c4cc4',
            cancelButtonColor: '#da292e'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await APIserver.post(`/api/actualizarv/facturasVenta/anular`, {
                        idFacV: factura.idFactura
                    });

                    if (response.status === 200) {
                        setFacturas(prevFacturas =>
                            prevFacturas.map(f =>
                                f.idFactura === factura.idFactura ? { ...f, estado: 'anulado' } : f
                            )
                        );
                        Swal.fire({
                            title: 'Anulada!',
                            text: `La factura ${factura.numeroFactura} ha sido anulada.`,
                            icon: 'success',
                            iconColor: '#2fb380',
                        });
                    } else {
                        console.error(`Error al anular factura: ${response.data.message}`);
                    }
                } catch (error) {
                    console.error('Error al anular factura:', error);
                    Swal.fire({
                        title: 'Error',
                        text: 'Hubo un problema al intentar anular la factura.',
                        icon: 'error',
                        iconColor: '#da292e',
                    });
                }
            }
        });
    };

    const renderPaginationItems = () => {
        const items = [];
        const pageRangeDisplayed = 5; // Mostrar 5 páginas a la vez
        let startPage = Math.max(1, currentPage - Math.floor(pageRangeDisplayed / 2));
        let endPage = Math.min(totalPages, startPage + pageRangeDisplayed - 1);

        if (endPage - startPage < pageRangeDisplayed - 1) {
            startPage = Math.max(1, endPage - pageRangeDisplayed + 1);
        }

        if (startPage > 1) {
            items.push(
                <Pagination.First key="first" onClick={() => handlePageChange(1)} />
            );
        }

        if (currentPage > 1) {
            items.push(
                <Pagination.Prev key="prev" onClick={() => handlePageChange(currentPage - 1)} />
            );
        }

        for (let number = startPage; number <= endPage; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === currentPage}
                    onClick={() => handlePageChange(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }

        if (currentPage < totalPages) {
            items.push(
                <Pagination.Next key="next" onClick={() => handlePageChange(currentPage + 1)} />
            );
        }

        if (endPage < totalPages) {
            items.push(
                <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
            );
        }

        return items;
    };
    const handleOpenPagoModal = (factura) => {
        setSelectedFactura(factura); // Asigna la factura seleccionada
        setShowPagoModal(true);      // Abre el modal de pago
    };

    const handleClosePagoModal = () => {
        setShowPagoModal(false);     // Cierra el modal de pago
        setSelectedFactura(null);    // Limpia la factura seleccionada
    };

    const handleOpenDevModal = (factura) => {
        setSelectedFactura(factura); // Asigna la factura seleccionada
        setShowDevModal(true);       // Abre el modal de devolución
    };

    const handleCloseDevModal = () => {
        setShowDevModal(false);      // Cierra el modal de devolución
        setSelectedFactura(null);    // Limpia la factura seleccionada
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses son de 0 a 11
        const year = date.getUTCFullYear();
        return `${day}/${month}/${year}`;
    };
    return (
        <div style={{ boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)" }}>
            <Table responsive className='text-center align-middle border'>
                <thead>
                    <tr>
                        <th colSpan={12}>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex flex-wrap'>
                                    <Button variant='link' size='sm' title='Filtrar' onClick={toggleFilters}>
                                        <Filter className='text-danger' size={20} />
                                    </Button>
                                </div>
                                <div>
                                    <Form.Select
                                        className='ms-2'
                                        value={rowsPerPage}
                                        onChange={handleChangeRowsPerPage}
                                    >
                                        <option value='5'>5</option>
                                        <option value='10'>10</option>
                                        <option value='20'>20</option>
                                        <option value='50'>50</option>
                                    </Form.Select>
                                </div>
                            </div>
                            <div className={`filter-options ${showFilters ? 'show' : ''}`}>
                                <FiltroFacturas onFilter={handleFilterChange} />
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <th>Factura</th>
                        <th>Cliente</th>
                        <th>Creacion</th>
                        <th>Forma Pago</th>
                        <th>Envio</th>
                        <th>Guia</th>
                        <th>transportadora</th>
                        <th>Total</th>
                        <th>Pagado</th>
                        <th>Pendiente</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {facturas.length > 0 ? (
                        facturas.map(factura => (
                            <tr key={factura.idFactura}>
                                <td>
                                    <Link to={`/admin/Facturas/DetallesFactura/${factura.idFactura}/`} className='text-decoration-none'>
                                        {factura.numeroFactura}
                                    </Link>
                                </td>
                                <td>
                                    <Link to={`/admin/Clientes/DetallesClientes/${factura.idCliente}/`} className='text-decoration-none'>
                                        {factura.clienteNombre}
                                    </Link>
                                </td>
                                <td>{formatDate(factura.fechaCreacion)}</td>
                                <td>{factura.formaPago}</td>
                                <td>${factura.cosEnvio.toLocaleString()}</td>
                                <td>{factura.numGuia}</td>
                                <td>{factura.transport}</td>
                                <td>${factura.total.toLocaleString()}</td>
                                <td>${factura.pagado.toLocaleString()}</td>
                                <td>${factura.pendiente.toLocaleString()}</td>
                                <td>
                                    <div className={factura.estado === 'pendiente' ? 'text-warning' : factura.estado === 'pagado' ? 'text-success' : factura.estado === 'vencido' ? 'text-danger' : 'text-muted'}>
                                        {factura.estado}
                                    </div>
                                </td>
                                <td>
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomToggle}>
                                            <ThreeDotsVertical />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <ButtonGroup>
                                                <Link to={`/admin/Facturas/DetallesFactura/${factura.idFactura}/`}>
                                                    <Button variant='link' className='text-dark' title='ver factura'>
                                                        <EyeFill size={18} />
                                                    </Button>
                                                </Link>
                                                <Button
                                                    variant='link'
                                                    className='text-success'
                                                    title='agregar pago'
                                                    onClick={() => handleOpenPagoModal(factura)}
                                                    disabled={factura.estado === 'anulado' || factura.estado === 'pagado'}
                                                >
                                                    <CashStack size={18} />
                                                </Button>

                                                <Link to={`/admin/Facturas/EditarFactura/${factura.idFactura}/`}>
                                                    <Button
                                                        variant='link'
                                                        className='text-warning'
                                                        title='editar factura'
                                                    >
                                                        <PencilFill size={18} />
                                                    </Button>
                                                </Link>

                                                <Button
                                                    variant='link'
                                                    className='text-danger'
                                                    title='anular factura'
                                                    onClick={() => anularFactura(factura)}
                                                    disabled={factura.estado === 'anulado' || factura.estado === 'pagado'}
                                                >
                                                    <XCircleFill size={18} />
                                                </Button>
                                                <Button
                                                    variant='link'
                                                    className='text-muted'
                                                    onClick={() => handleOpenDevModal(factura)}
                                                    disabled={factura.estado === 'anulado'}
                                                    title='devolucion'
                                                >
                                                    <ArrowClockwise size={18} />
                                                </Button>
                                            </ButtonGroup>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={10}>No hay facturas para mostrar</td>
                        </tr>
                    )}
                </tbody>
                {totalPages > 1 && (
                    <tfoot>
                        <tr>
                            <td colSpan={12}>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <Pagination>
                                        {renderPaginationItems()}
                                    </Pagination>
                                </div>
                            </td>
                        </tr>
                    </tfoot>
                )}
            </Table>

            {/* Modal para crear pago */}
            {showPagoModal && (
                <CrearPagoResModal
                    show={showPagoModal}
                    handleClose={handleClosePagoModal} // Control específico para cerrar el modal de pago
                    factura={selectedFactura}         // Pasar la factura seleccionada como prop
                />
            )}

            {/* Modal para crear devolución */}
            {showDevModal && (
                <CrearModalDev
                    show={showDevModal}
                    handleClose={handleCloseDevModal} // Control específico para cerrar el modal de devolución
                    numeroFactura={selectedFactura?.numeroFactura} // Pasar el número de factura seleccionado como prop
                />
            )}


        </div>
    );
}

export default TablaFacturas;